
import React from 'react'
import { renderLevel } from '../../../../utils/alertUtils'
import { productConfig } from '../../../../config/config-service'
import CarePlanItem, { type ICarePlanItemProps } from '../CarePlanItem'
import { CAREPLAN_VALUE_TYPES } from '../../../../constants/carePlanValueTypes'
import { Box } from '@mui/material'

export default class BloodGlucoseRangeItem extends CarePlanItem {
  constructor (props: ICarePlanItemProps) {
    super(props)
    this.type = 'bg_range'
    this.config = productConfig()
  }

  rangeBloodGlucoseMinInputElement (): JSX.Element {
    return this.getInputElement(
      50, 150, 10,
      CAREPLAN_VALUE_TYPES.BLOOD_GLUCOSE_MIN.get(val => val),
      CAREPLAN_VALUE_TYPES.BLOOD_GLUCOSE_MIN.set(val => val)
    )
  }

  rangeBloodGlucoseMaxInputElement (): JSX.Element {
    return this.getInputElement(
      200, 500, 10,
      CAREPLAN_VALUE_TYPES.BLOOD_GLUCOSE_MAX.get(val => val),
      CAREPLAN_VALUE_TYPES.BLOOD_GLUCOSE_MAX.set(val => val)
    )
  }

  renderGoal (): JSX.Element {
    return <div>Keep blood glucose in range</div>
  }

  renderClinicianTrigger (): JSX.Element {
    return <div>If blood glucose is below {this.rangeBloodGlucoseMinInputElement()} or above {this.rangeBloodGlucoseMaxInputElement()} mg/dL.</div>
  }

  renderCondensed (): JSX.Element {
    const className = this.state.itemData?.disabled === 1 ? 'disabled' : ''
    const level = this.state.itemData?.level ? renderLevel(this.state.itemData.level, true) : ''
    return <Box className={className}>{level} BG &lt; {this.getValueElement(CAREPLAN_VALUE_TYPES.BLOOD_GLUCOSE_MIN.get(val => val))} or &gt; {this.getValueElement(CAREPLAN_VALUE_TYPES.BLOOD_GLUCOSE_MAX.get(val => val))} mg/dL</Box>
  }
}
